export default [
  {
    id: 1,
    value: 'shred_requested',
    name: 'Shred requested',
    result_item_field: 'is_shred_complete'
  },
  {
    id: 2,
    value: 'scan_requested',
    name: 'Scan requested',
    result_item_field: 'is_scan_complete'
  },
  {
    id: 3,
    value: 'same_day_scan_requested',
    name: 'Same day scan requested',
    result_item_field: 'is_scan_complete'
  },
  {
    id: 4,
    value: 'two_days_scan_requested',
    name: 'Two days scan requested',
    result_item_field: 'is_scan_complete'
  },
  {
    id: 5,
    value: 'forward_requested',
    name: 'Forward requested',
    result_item_field: 'is_forward_complete'
  },
  {
    id: 6,
    value: 'expedited_forward_requested',
    name: 'Expedited forward requested',
    result_item_field: 'is_forward_complete'
  },
  {
    id: 7,
    value: 'envelope_picture_requested',
    name: 'Envelope picture requested',
    result_item_field: 'picture_added_at'
  },
  {
    id: 8,
    value: 'pick_up_requested',
    name: 'Pick up requested',
    result_item_field: 'is_pick_up_complete'
  },
  {
    id: 9,
    value: 'mark_as_pick_up_requested',
    name: 'Mark as picked up requested',
    result_item_field: 'mark_as_pick_up_complete'
  },
  {
    id: 10,
    value: 'mark_as_junk',
    name: 'Mark as junk'
  }
]